import lodash from 'lodash';
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  computed: {
    ...mapGetters({
      passwordValidation: 'profile/dashboard/passwordValidation',
      currentPasswordError: 'forms/updatePassword/currentPasswordError'
    }),
    errorMessage() {
      if (!this.$v.password.$error) {
        return '';
      }
      let message = this.$t('renewPassword.generatedError.start');
      let minLength = [];
      let messageAdons = [];
      if (this.passwordValidation.minLength) {
        minLength.push(
          this.$t('renewPassword.generatedError.minLength', {
            length: this.passwordValidation.minLength
          })
        );
      }
      if (this.passwordValidation.lettersCount) {
        messageAdons.push(
          this.passwordValidation.lettersCount +
            ' ' +
            this.$t('renewPassword.generatedError.oneChar')
        );
      }
      if (this.passwordValidation.digitsCount) {
        messageAdons.push(
          this.passwordValidation.digitsCount +
            ' ' +
            this.$t('renewPassword.generatedError.oneNumber')
        );
      }
      if (
        this.passwordValidation.specialChars &&
        this.passwordValidation.specialChars.length &&
        this.passwordValidation.specialCharsCount &&
        this.passwordValidation.specialCharsCount > 0
      ) {
        messageAdons.push(
          this.passwordValidation.specialCharsCount +
            ' ' +
            this.$t('renewPassword.generatedError.specialChar') +
            ' ' +
            this.passwordValidation.specialChars
        );
      }

      if (minLength.length) {
        message += ' ' + minLength[0];
      }

      if (messageAdons.length) {
        message +=
          ', ' + this.$t('renewPassword.generatedError.require') + ' ' + messageAdons.join(', ');
      }

      return message;
    }
  },
  methods: {
    generatePasswordVuelidation(isRequired = false) {
      let passwordValidation = isRequired ? { required } : {};

      if (!lodash.isEmpty(this.passwordValidation)) {
        if (this.passwordValidation.minLength) {
          passwordValidation.length = value => {
            return (value?.length ?? 0) >= this.passwordValidation.minLength;
          };
        }

        if (this.passwordValidation.lettersCount) {
          passwordValidation.lettersCount = value => {
            let letters =
              value?.match(/[A-zÀ-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿЀ-ӿ]/g) ||
              [];
            return letters.length >= this.passwordValidation.lettersCount;
          };
        }

        if (this.passwordValidation.digitsCount) {
          passwordValidation.digitCount = value => {
            let digits = value?.match(/[\d]/g) || [];
            return digits.length >= this.passwordValidation.digitsCount;
          };
        }

        if (
          this.passwordValidation.specialChars &&
          this.passwordValidation.specialChars.length &&
          this.passwordValidation.specialCharsCount &&
          this.passwordValidation.specialCharsCount > 0
        ) {
          passwordValidation.specialChars = value => {
            let re = new RegExp(
              '[\\' + this.passwordValidation.specialChars.split('').join('\\') + ']',
              'g'
            );
            let specialChars = value?.match(re) || [];
            return specialChars.length >= this.passwordValidation.specialCharsCount;
          };
        }
      }

      return {
        ...passwordValidation
      };
    }
  }
};
